<template>
  <base-card class="h-100 d-flex align-items-center">
    <div class="d-flex flex-wrap align-items-center py-2 px-3">
      <div
        v-for="(item, index) in items"
        :key="`sales_summary_stat_${index}`"
        class="col-6 text-center"
        :class="`divider ${index % 2 === 0 ? 'pl-2 pr-4' : 'left pl-4 pr-2'} ${index <= 1 ? 'bottom pt-2 pb-4' : 'pt-4 pb-2'}`"
      >
        <base-text class="label mb-1">
          {{ item.label }}
        </base-text>
        <base-text
          v-if="item.value !== null"
          class="value"
        >
          {{ item.value | formatPrice(0) }}
        </base-text>
        <base-text v-else>
          --
        </base-text>
      </div>
    </div>
  </base-card>
</template>
<script>
export default {
  name: 'SalesSummaryGrid',
  props: {
    items: {
      type: Array,
      validator: (list) => list.length === 4,
      required: true,
    },
  },
  data() {
    return {

    };
  },
};
</script>
<style lang="scss"
       scoped>
.label {
  font-size: 15px;
  letter-spacing: 1px !important;
}
.value {
  font-size: 17px;
  font-family: $font-family-sans-serif-medium;
  letter-spacing: 1px !important;
}
.divider {
  &.left{
    border-left: solid 1px rgba($clementine, 0.5);
  }
  &.bottom {
    border-bottom: solid 1px rgba($clementine, 0.5);
  }
}
</style>
